/* istanbul ignore file */
import {
  useApi,
  fetchApiRef,
  discoveryApiRef,
} from "@backstage/core-plugin-api";
import { useMemo } from "react";
import { StanClient } from "./stan-client";

export const useStanClient = () => {
  const fetchApi = useApi(fetchApiRef);
  const discoveryApi = useApi(discoveryApiRef);

  return useMemo(
    () => new StanClient({ fetchApi, discoveryApi }),
    [fetchApi, discoveryApi]
  );
};
